export const DELIVERY_TO = {
  entrance: 'до подъезда',
  apartment: 'до квартиры'
}
